import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectUnreadRepliesCounter } from 'src/app/data/store/selectors/users.selectors';
import { TextSizes, TextType } from '../../enums';
import { AsyncPipe } from '@angular/common';
import { TextComponent } from '../text/text.component';
@Component({
  selector: 'app-notifications-counter',
  templateUrl: './notifications-counter.component.html',
  styleUrls: ['./notifications-counter.component.scss'],
  imports: [TextComponent, AsyncPipe],
})
export class NotificationsCounterComponent {
  private _store = inject(Store);

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public unreadReplies$: Observable<number | undefined> = this._store.select(
    selectUnreadRepliesCounter,
  );
}
